import { RouteType } from "types/RouteType";
import type RootStore from "stores/RootStore";
import type BulkPaystubStore from "./BulkPaystub.Store";

/**
 * Bulk Paystub Printing Route
 * Admin-only view for bulk downloading paystubs for multiple workers
 */
export const bulkPaystubRoute: RouteType = {
  name: "Bulk Paystub Printing",
  path: "/payroll/admin/bulk-paystubs",
  layout: "/app",
  defaultQueryParams: { companyId: "H2" },
  viewportCard: {
    header: {
      title: "Bulk Paystub Printing",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./BulkPaystub.Header"),
    },
    body: {
      component: () => import("./BulkPaystub.Body"),
      grayBackground: true,
    },
  },
  dialogs: [
    {
      name: "SingleWorkerPaystubDialog",
      title: "Worker Paystub History",
      component: () => import("./SingleWorkerPaystubDialog"),
      maxWidth: "md",
    },
    {
      name: "BulkPaystubPrintDialog",
      title: "Bulk Paystub Download",
      component: () => import("./BulkPaystubPrintDialog"),
      maxWidth: "lg",
    },
  ],
  group: "Payroll Admin",
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = rootStore.bulkPaystubStore as BulkPaystubStore;
    const companyId = rootStore.routerStore?.queryParams?.companyId as string;
    if (store) {
      await store.loadWorkers(companyId);
    }
    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = rootStore.bulkPaystubStore as BulkPaystubStore;
    const companyId = rootStore.routerStore?.queryParams?.companyId as string;
    if (store) {
      // Clear selection when company changes
      store.clearSelection();
      await store.loadWorkers(companyId);
    }
  },
};

export default bulkPaystubRoute;
